import "core-js";
import "regenerator-runtime/runtime";
import 'url-polyfill';

window.Proxy = window.Proxy || function Proxy(target) {
  return target;
};

(function polyfillCustomEvent() {

  if ( typeof window.CustomEvent === "function" ) return false;

  function CustomEvent ( event, params ) {
    params = params || { bubbles: false, cancelable: false, detail: null };
    var evt = document.createEvent( 'CustomEvent' );
    evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
    return evt;
   }

  window.CustomEvent = CustomEvent;
})();
